module.exports = __webpack_public_path__ + "img/faceheart-logo.4a146650.png";